import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { TAFS_LEGEND } from './tafs.legend';
import { TAFS_PRODUCT_DATA } from './tafs.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class TAFsPluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(TAFS_PRODUCT_DATA, {
    legend: TAFS_LEGEND,
    twcLayerTypes: ['vector-tile']
  });
}
